import React, { useState } from 'react'

import * as S from './styles'

import { Typography } from '../../../components/Typography/styles'
import HomeIcon from '../../../assets/Icons/HomeIcon'
import DashIcon from '../../../assets/Icons/DashIcon'
import UsersIcon from '../../../assets/Icons/UsersIcon'
import CertificateIcon from '../../../assets/Icons/CertificateIcon'
import PlansIcon from '../../../assets/Icons/PlansIcon'
import history from '../../../store/history'

const SideBar = ({ path }) => {
  const [selected, setSelected] = useState(path)

  const handleClick = (value) => {
    const pathNames = {
      dashboard: { name: 'dashboard', path: '/admin/dashboard' },
      empresas: { name: 'empresas', path: '/admin/companies' },
      certificados: { name: 'certificados', path: '/admin/certificates' },
      usuarios: { name: 'usuarios', path: '/admin/usuarios' },
      revisao: { name: 'revisao', path: '/admin/review' },
      configuration: { name: 'configuration', path: '/admin/configuration' }
    }

    setSelected(pathNames[value].name)
    history.push(pathNames[value].path)
  }

  return (
    <S.SideBarContainer>
      <S.ButtonContainer onClick={() => handleClick('dashboard')}>
        <S.IconContainer selected={selected === 'dashboard'}>
          <HomeIcon color={selected === 'dashboard' ? '#BE9137' : '#DFE6F1'} />
          <Typography
            type="label"
            spacing="4px 0 0 0"
            weight={selected === 'dashboard' ? 800 : 'normal'}
          >
            {' '}
            DashBoard
          </Typography>
        </S.IconContainer>
      </S.ButtonContainer>
      <S.ButtonContainer onClick={() => handleClick('empresas')}>
        <S.IconContainer selected={selected === 'empresas'}>
          <DashIcon color={selected === 'empresas' ? '#BE9137' : '#DFE6F1'} />
          <Typography
            type="label"
            spacing="4px 0 0 0"
            weight={selected === 'empresas' ? 800 : 'normal'}
          >
            {' '}
            Empresas
          </Typography>
        </S.IconContainer>
      </S.ButtonContainer>
      <S.ButtonContainer onClick={() => handleClick('certificados')}>
        <S.IconContainer selected={selected === 'certificados'}>
          <CertificateIcon
            color={selected === 'certificados' ? '#BE9137' : '#DFE6F1'}
          />
          <Typography
            type="label"
            spacing="4px 0 0 0"
            weight={selected === 'certificados' ? 800 : 'normal'}
          >
            {' '}
            Certificados
          </Typography>
        </S.IconContainer>
      </S.ButtonContainer>
      <S.ButtonContainer onClick={() => handleClick('usuarios')}>
        <S.IconContainer selected={selected === 'usuarios'}>
          <UsersIcon color={selected === 'usuarios' ? '#BE9137' : '#DFE6F1'} />
          <Typography
            type="label"
            spacing="4px 0 0 0"
            weight={selected === 'usuarios' ? 800 : 'normal'}
          >
            {' '}
            Usuários
          </Typography>
        </S.IconContainer>
      </S.ButtonContainer>
      <S.ButtonContainer onClick={() => handleClick('revisao')}>
        <S.IconContainer selected={selected === 'revisao'}>
          <PlansIcon color={selected === 'revisao' ? '#BE9137' : '#DFE6F1'} />
          <Typography
            type="label"
            spacing="4px 0 0 0"
            weight={selected === 'revisao' ? 800 : 'normal'}
          >
            {' '}
            Revisão
          </Typography>
        </S.IconContainer>
      </S.ButtonContainer>
      <S.ButtonContainer onClick={() => handleClick('configuration')}>
        <S.IconContainer selected={selected === 'configuration'}>
          <DashIcon
            color={selected === 'configuration' ? '#BE9137' : '#DFE6F1'}
          />
          <Typography
            type="label"
            spacing="4px 0 0 0"
            weight={selected === 'configuration' ? 800 : 'normal'}
          >
            {' '}
            Configurações
          </Typography>
        </S.IconContainer>
      </S.ButtonContainer>
    </S.SideBarContainer>
  )
}

export default SideBar
